import React, { useContext, useEffect, useState } from 'react';
import * as yup from 'yup';
import { ApiContext } from '@api/api';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { CompanyInfoInDTO } from '@api/ringil-api.v2';
import useForm from '@hooks/useForm/useForm';
import RingilSidebar from '@components/ringil3/Sidebar/RingilSidebar.tsx';
import { Field } from '@components/framework/formfield/Field.tsx';
import RingilInputText from '@components/framework/input/RingilInput/RingilInputText.tsx';

interface ComponentProps {
  onChanged: () => void;
}

export const createEditCompanyNameSidebar = () => {
  const [visible, setVisible] = useState(false);
  const { tr } = useTranslationLgs();
  const { getCompanyForCurrentUser, updateCompanyInfo } = useContext(ApiContext);

  const EditCompanyNameSidebar: React.FC<ComponentProps> = ({ onChanged }) => {
    useEffect(() => {
      getCompanyForCurrentUser(d => {
        form.setValues(d);
      });
    }, [visible]);

    const validationSchema = yup.object().shape({
      city: yup.string().required(),
      companyName: yup.string().required(),
      country: yup.string().required(),
      streetNr: yup.string().required(),
      zipCode: yup.string().required(),
    });

    const form = useForm<CompanyInfoInDTO>(
      validationSchema,
      {
        city: '',
        companyName: '',
        country: '',
        streetNr: '',
        zipCode: '',
      },
      values => {
        save(values);
      },
      false,
      false,
    );

    const save = (values: CompanyInfoInDTO) => {
      updateCompanyInfo(values, () => {
        setVisible(false);
        onChanged();
      });
    };

    return (
      <RingilSidebar
        visible={visible}
        onBack={() => setVisible(false)}
        heading={tr('EditCompanyNameSidebar.titleUpdateCompanyName', 'Update company name')}
        onContinue={() => {
          form.validateAndSend();
        }}
      >
        <Field
          label={tr('EditCompanyNameSidebar.companyName', 'Company name')}
          errorMessage={form.errors.companyName}
          required
        >
          <RingilInputText
            value={form.values.companyName}
            onChange={v => form.setFieldValue(form.names.companyName, v)}
            fullWidth
          />
        </Field>
      </RingilSidebar>
    );
  };

  return { setVisible, EditCompanyNameSidebar };
};
